<template>
  <div>
    <div class="accordion" role="tablist" v-if="project.measurement && project.qualityReport">
      <Roof :cards="cards" :project="project" :referenceData="referenceData" />

      <h1>1. {{ $t('tileRoofState') }} ({{ $t('dcInside') }})</h1>
      <DcInside :cards="cards" :project="project" :referenceData="referenceData" />

      <div v-if="isPitchedRoof">
        <h1>2. {{ $t('informative') }} ({{ $t('pitchedRoofDcExterior') }})</h1>
        <Informative :cards="cards" :project="project" :referenceData="referenceData" />
        <h1>3. {{ $t('substructure') }} ({{ $t('pitchedRoofDcExterior') }})</h1>
        <Substructure :cards="cards" :project="project" :referenceData="referenceData" />
        <h1>4. {{ $t('rafters') }} ({{ $t('pitchedRoofDcExterior') }})</h1>
        <Rafters :cards="cards" :project="project" :referenceData="referenceData" />
        <h1>5. {{ $t('tileRoofState') }} ({{ $t('pitchedRoofDcExterior') }})</h1>
        <TileRoof :cards="cards" :project="project" :referenceData="referenceData" />
        <h1>6. {{ $t('cables') }} ({{ $t('pitchedRoofDcExterior') }})</h1>
        <Cables :cards="cards" :project="project" :referenceData="referenceData" />
      </div>

      <div v-if="isFlatRoof">
        <h1>2. {{ $t('informativeAndCommon') }} ({{ $t('flatRoof') }} {{ $t('DC') }})</h1>
        <InformativeFlatRoof :cards="cards" :project="project" :referenceData="referenceData" />
        <h1>3. {{ $t('flatRoof') }} ({{ $t('flatRoof') }} {{ $t('DC') }})</h1>
        <FlatRoof :cards="cards" :project="project" :referenceData="referenceData" />
        <h1>4. {{ $t('cables') }} ({{ $t('flatRoof') }} {{ $t('DC') }})</h1>
        <CablesFlatRoof :cards="cards" :project="project" :referenceData="referenceData" />
      </div>

      <h1>
        <span v-if="isPitchedRoof">7</span>
        <span v-else>5</span>. {{ $t('informativeAndCommon') }} ({{ $t('AC') }})
      </h1>
      <InformativeAC :cards="cards" :project="project" :referenceData="referenceData" />

      <h1>
        <span v-if="isPitchedRoof">8</span>
        <span v-else>6</span>. {{ $t('cables') }} ({{ $t('AC') }})
      </h1>
      <Wiring :cards="cards" :project="project" :referenceData="referenceData" />

      <!-- <h1>
        <span v-if="isPitchedRoof">9</span>
        <span v-else>7</span>. {{ $t('measurements') }} ({{ $t('AC') }})
      </h1>
      <Measurements :cards="cards" :project="project" :referenceData="referenceData" /> -->
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import {
  MEASUREMENT_ROOF_TYPE_PATH,
  toQualityCardInput,
} from '@/blocks/project/projectQualityReportDataInput';
import { ReportCardsMixin } from '@/mixins/reportCards';
import Roof from './MobileMeasurement/Roof.vue';

import DcInside from './MobileQuality/DcInside.vue';
import Informative from './MobileQuality/Informative.vue';
import Substructure from './MobileQuality/Substructure.vue';
import Rafters from './MobileQuality/Rafters.vue';
import Cables from './MobileQuality/Cables.vue';
import TileRoof from './MobileQuality/TileRoof.vue';
import CablesFlatRoof from './MobileQuality/CablesFlatRoof.vue';
import FlatRoof from './MobileQuality/FlatRoof.vue';
import InformativeFlatRoof from './MobileQuality/InformativeFlatRoof.vue';
import InformativeAC from './MobileQuality/InformativeAC.vue';
import Wiring from './MobileQuality/Wiring.vue';
import Measurements from './MobileQuality/Measurements.vue';

/**
 * Cards of the tab Qualitätsprotokoll (see feature page projekt-protokolle). In the block
 * project-quality-report-data each card is saved on its own (`saveCard`); the deprecated mobile
 * layout imports this view without it and saves the whole project. Every card state, the roof
 * type card's included, lives in `qualityReport.completed`.
 */
export default {
  name: 'MobileProjectsReport',
  components: {
    Roof,
    DcInside,
    Informative,
    Substructure,
    Rafters,
    TileRoof,
    Cables,
    InformativeFlatRoof,
    FlatRoof,
    CablesFlatRoof,
    InformativeAC,
    Wiring,
    // Measurements,
  },
  mixins: [ReportCardsMixin],
  props: {
    project: { type: Object },
  },
  data() {
    return {
      reportPath: 'qualityReport',
      cards: {
        /** 1. Dachtyp */
        roofType: {
          name: 'roofType',
          fields: [MEASUREMENT_ROOF_TYPE_PATH],
          opened: true,
          navigateTo: this.goToCard,
          successor: 'isRoofAccessibleFromInsideState',
          predecessor: null,
          completed: this.completedState,
        },
        /** st das Dach von der Innenseite prüfbar? */
        isRoofAccessibleFromInsideState: {
          name: 'isRoofAccessibleFromInsideState',
          fields: ['isRoofAccessibleFromInsideState', 'isRoofAccessibleFromInsideNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'properSleeveUsedAtRoofPenetrationState',
          predecessor: 'roofType',
          completed: this.completedState,
        },
        /** Ordentlich verwendete Manschette bei Dachdurchführung */
        properSleeveUsedAtRoofPenetrationState: {
          name: 'properSleeveUsedAtRoofPenetrationState',
          fields: [
            'properSleeveUsedAtRoofPenetrationState',
            'properSleeveUsedAtRoofPenetrationNote',
          ],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'underlaySealedWellAtCableEntryState',
          predecessor: 'isRoofAccessibleFromInsideState',
          completed: this.completedState,
        },
        /**  Unterspannbahn gut abgedichtet bei Kabeleintritt */
        underlaySealedWellAtCableEntryState: {
          name: 'underlaySealedWellAtCableEntryState',
          fields: ['underlaySealedWellAtCableEntryState', 'underlaySealedWellAtCableEntryNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'underlayDamagedOrWaterStainsState',
          predecessor: 'properSleeveUsedAtRoofPenetrationState',
          completed: this.completedState,
        },
        /** Unterspannbahn beschädigt oder Wasserschäden */
        underlayDamagedOrWaterStainsState: {
          name: 'underlayDamagedOrWaterStainsState',
          fields: ['underlayDamagedOrWaterStainsState', 'underlayDamagedOrWaterStainsNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'labelingOfStringLinesState',
          predecessor: 'underlaySealedWellAtCableEntryState',
          completed: this.completedState,
        },
        /**  Beschriftung der String-Leitungen */
        labelingOfStringLinesState: {
          name: 'labelingOfStringLinesState',
          fields: ['labelingOfStringLinesState', 'labelingOfStringLinesNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'pvStringCableCorrectCrossSectionState',
          predecessor: 'underlayDamagedOrWaterStainsState',
          completed: this.completedState,
        },
        /**  PV-Stringkabel korrekter Querschnitt */
        pvStringCableCorrectCrossSectionState: {
          name: 'pvStringCableCorrectCrossSectionState',
          fields: ['pvStringCableCorrectCrossSectionState', 'pvStringCableCorrectCrossSectionNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'peCableCorrectlySizedState',
          predecessor: 'labelingOfStringLinesState',
          completed: this.completedState,
        },
        /** Funktions-Potentialausgleich zur PAS von  UK=6mm² */
        peCableCorrectlySizedState: {
          name: 'peCableCorrectlySizedState',
          fields: ['peCableCorrectlySizedState', 'peCableCorrectlySizedNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'cablesProperlySecuredState',
          predecessor: 'pvStringCableCorrectCrossSectionState',
          completed: this.completedState,
        },
        /**  Leitungen befestigt mit Schellen, Rohren, Kabelkanal? */
        cablesProperlySecuredState: {
          name: 'cablesProperlySecuredState',
          fields: ['cablesProperlySecuredState', 'cablesProperlySecuredNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'crimpingProfessionallyDoneState',
          predecessor: 'peCableCorrectlySizedState',
          completed: this.completedState,
        },
        /**  Crimpung/Aderendhülsen  fachgerecht durchgeführt? */
        crimpingProfessionallyDoneState: {
          name: 'crimpingProfessionallyDoneState',
          fields: ['crimpingProfessionallyDoneState', 'crimpingProfessionallyDoneNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'correctSelectionOfPvConnectorsOnStringCableState',
          predecessor: 'cablesProperlySecuredState',
          completed: this.completedState,
        },
        /** Richtige Auswahl der PV-Stecker am Stringkabel */
        correctSelectionOfPvConnectorsOnStringCableState: {
          name: 'correctSelectionOfPvConnectorsOnStringCableState',
          fields: [
            'correctSelectionOfPvConnectorsOnStringCableState',
            'correctSelectionOfPvConnectorsOnStringCableNote',
          ],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'allPlugConnectionsProfessionallyMadeState',
          predecessor: 'crimpingProfessionallyDoneState',
          completed: this.completedState,
        },
        /**  Alle Steckerverbindungen fachgerecht gesteckt */
        allPlugConnectionsProfessionallyMadeState: {
          name: 'allPlugConnectionsProfessionallyMadeState',
          fields: [
            'allPlugConnectionsProfessionallyMadeState',
            'allPlugConnectionsProfessionallyMadeNote',
          ],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'cablesNeatlyLaidInsideBuildingState',
          predecessor: 'correctSelectionOfPvConnectorsOnStringCableState',
          completed: this.completedState,
        },
        /**  Kabel sauber im Gebäudeinneren verlegt */
        cablesNeatlyLaidInsideBuildingState: {
          name: 'cablesNeatlyLaidInsideBuildingState',
          fields: ['cablesNeatlyLaidInsideBuildingState', 'cablesNeatlyLaidInsideBuildingNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'spdBoxPresentIfCableInBuildingLongerThan10mInstalledBeforeInverterState',
          predecessor: 'allPlugConnectionsProfessionallyMadeState',
          completed: this.completedState,
        },
        /**  falls Leitung in Gebäude länger als 10m eine 2. vorm WR verbaut */
        spdBoxPresentIfCableInBuildingLongerThan10mInstalledBeforeInverterState: {
          name: 'spdBoxPresentIfCableInBuildingLongerThan10mInstalledBeforeInverterState',
          fields: [
            'spdBoxPresentIfCableInBuildingLongerThan10mInstalledBeforeInverterState',
            'spdBoxPresentIfCableInBuildingLongerThan10mInstalledBeforeInverterNote',
          ],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'surgeProtectionBoxProperlyWiredInstallSpdAtRoofEntryState',
          predecessor: 'cablesNeatlyLaidInsideBuildingState',
          completed: this.completedState,
        },
        /**  Überspannungsbox richtig verdrahtet? */
        surgeProtectionBoxProperlyWiredInstallSpdAtRoofEntryState: {
          name: 'surgeProtectionBoxProperlyWiredInstallSpdAtRoofEntryState',
          fields: [
            'surgeProtectionBoxProperlyWiredInstallSpdAtRoofEntryState',
            'surgeProtectionBoxProperlyWiredInstallSpdAtRoofEntryNote',
          ],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'isConnectorSealingIntactState',
          predecessor: 'spdBoxPresentIfCableInBuildingLongerThan10mInstalledBeforeInverterState',
          completed: this.completedState,
        },

        isConnectorSealingIntactState: {
          name: 'isConnectorSealingIntactState',
          fields: ['isConnectorSealingIntactState', 'isConnectorSealingIntactNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'isSurgeProtectionBoxPresenState',
          predecessor: 'surgeProtectionBoxProperlyWiredInstallSpdAtRoofEntryState',
          completed: this.completedState,
        },
        isSurgeProtectionBoxPresenState: {
          name: 'isSurgeProtectionBoxPresenState',
          fields: ['isSurgeProtectionBoxPresenState', 'isSurgeProtectionBoxPresentNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'isSurgeProtectionAtHouseEntryState',
          predecessor: 'isConnectorSealingIntactState',
          completed: this.completedState,
        },
        isSurgeProtectionAtHouseEntryState: {
          name: 'isSurgeProtectionAtHouseEntryState',
          fields: ['isSurgeProtectionAtHouseEntryState', 'isSurgeProtectionAtHouseEntryNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'documentationProjectReportAvailableState',
          predecessor: 'isSurgeProtectionBoxPresenState',
          completed: this.completedState,
        },
        documentationProjectReportAvailableState: {
          name: 'documentationProjectReportAvailableState',
          fields: [
            'documentationProjectReportAvailableState',
            'documentationProjectReportAvailableNote',
          ],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'specialCustomerRequestsDocumentedState',
          predecessor: 'isSurgeProtectionAtHouseEntryState',
          completed: this.completedState,
        },
        /** Gibt es Sonderwünsche des Kunden und wurden Dokumentiert? */
        specialCustomerRequestsDocumentedState: {
          name: 'specialCustomerRequestsDocumentedState',
          fields: [
            'specialCustomerRequestsDocumentedState',
            'specialCustomerRequestsDocumentedNote',
          ],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'tileTypeAndWidthDocumentedState',
          predecessor: 'documentationProjectReportAvailableState',
          completed: this.completedState,
        },
        /** Ziegelart und Ziegeldeckbreite dokumentiert? */
        tileTypeAndWidthDocumentedState: {
          name: 'tileTypeAndWidthDocumentedState',
          fields: ['tileTypeAndWidthDocumentedState', 'tileTypeAndWidthDocumentedNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'replacementTileInstalledState',
          predecessor: 'specialCustomerRequestsDocumentedState',
          completed: this.completedState,
        },
        /** Ziegelersatzplatte verbaut? */
        replacementTileInstalledState: {
          name: 'replacementTileInstalledState',
          fields: ['replacementTileInstalledState', 'replacementTileInstalledNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'lightningProtectionPresentState',
          predecessor: 'tileTypeAndWidthDocumentedState',
          completed: this.completedState,
        },
        /** Blitzschutz vorhanden? */
        lightningProtectionPresentState: {
          name: 'lightningProtectionPresentState',
          fields: ['lightningProtectionPresentState', 'lightningProtectionPresentNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'substructureTensionFreeCheckedState',
          predecessor: 'replacementTileInstalledState',
          completed: this.completedState,
        },
        /** Schiene ordnungsgemäß montiert */
        substructureTensionFreeCheckedState: {
          name: 'substructureTensionFreeCheckedState',
          fields: ['substructureTensionFreeCheckedState', 'substructureTensionFreeCheckedNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'substructureInstalledAsPerReportState',
          predecessor: 'lightningProtectionPresentState',
          completed: this.completedState,
        },
        /** UK nach Projektbericht verbaut? */
        substructureInstalledAsPerReportState: {
          name: 'substructureInstalledAsPerReportState',
          fields: ['substructureInstalledAsPerReportState', 'substructureInstalledAsPerReportNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'eachRailSecuredWithMinTwoHooksState',
          predecessor: 'substructureTensionFreeCheckedState',
          completed: this.completedState,
        },
        /** Jede Schiene ist mit mind. 2 Dachhaken befestigt? */
        eachRailSecuredWithMinTwoHooksState: {
          name: 'eachRailSecuredWithMinTwoHooksState',
          fields: ['eachRailSecuredWithMinTwoHooksState', 'eachRailSecuredWithMinTwoHooksNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'distanceBetweenHooksMoreThan140cmState',
          predecessor: 'substructureInstalledAsPerReportState',
          completed: this.completedState,
        },
        /** Abstand zwischen Haken kleiner als 140cm? */
        distanceBetweenHooksMoreThan140cmState: {
          name: 'distanceBetweenHooksMoreThan140cmState',
          fields: [
            'distanceBetweenHooksMoreThan140cmState',
            'distanceBetweenHooksMoreThan140cmNote',
          ],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'correctRoofHooksUsedState',
          predecessor: 'eachRailSecuredWithMinTwoHooksState',
          completed: this.completedState,
        },
        /** Dachhaken ordnungsgemäß montiert */
        correctRoofHooksUsedState: {
          name: 'correctRoofHooksUsedState',
          fields: ['correctRoofHooksUsedState', 'correctRoofHooksUsedNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'distanceRoofHookToTile35mmState',
          predecessor: 'distanceBetweenHooksMoreThan140cmState',
          completed: this.completedState,
        },
        /** Abstand Dachhaken zum darunter liegenden Ziegel von 3-5mm? */
        distanceRoofHookToTile35mmState: {
          name: 'distanceRoofHookToTile35mmState',
          fields: ['distanceRoofHookToTile35mmState', 'distanceRoofHookToTile35mmNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'minScrewDistanceToRafterEdge24mmState',
          predecessor: 'correctRoofHooksUsedState',
          completed: this.completedState,
        },
        /** Mindestabstand Schrauben zur Sparrenkante kleiner als 24mm? */
        minScrewDistanceToRafterEdge24mmState: {
          name: 'minScrewDistanceToRafterEdge24mmState',
          fields: ['minScrewDistanceToRafterEdge24mmState', 'minScrewDistanceToRafterEdge24mmNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'roofHookProperlyFixedToRafterState',
          predecessor: 'distanceRoofHookToTile35mmState',
          completed: this.completedState,
        },
        /** Dachhaken richtig auf Sprarren befestigt? */
        roofHookProperlyFixedToRafterState: {
          name: 'roofHookProperlyFixedToRafterState',
          fields: ['roofHookProperlyFixedToRafterState', 'roofHookProperlyFixedToRafterNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'overhangObservedState',
          predecessor: 'minScrewDistanceToRafterEdge24mmState',
          completed: this.completedState,
        },
        /** Kragarm eingehalten? (TP37 - 35cm; TP45 & TP65 - 45cm) */
        overhangObservedState: {
          name: 'overhangObservedState',
          fields: ['overhangObservedState', 'overhangObservedNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'moduleFieldProperlyGroundedState',
          predecessor: 'roofHookProperlyFixedToRafterState',
          completed: this.completedState,
        },
        /** Modulfeld fachgerecht untereinander geerdet? */
        moduleFieldProperlyGroundedState: {
          name: 'moduleFieldProperlyGroundedState',
          fields: ['moduleFieldProperlyGroundedState', 'moduleFieldProperlyGroundedNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'approvedAuxiliaryRafterUsedState',
          predecessor: 'overhangObservedState',
          completed: this.completedState,
        },
        /** Freigegebener Hilfssparren verwendet (Statikgutachen)? */
        approvedAuxiliaryRafterUsedState: {
          name: 'approvedAuxiliaryRafterUsedState',
          fields: ['approvedAuxiliaryRafterUsedState', 'approvedAuxiliaryRafterUsedNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'rafterWidthMeasuredAndComparedToDocsState',
          predecessor: 'moduleFieldProperlyGroundedState',
          completed: this.completedState,
        },
        /** Sparrenbreite mind. 60mm   (laut Dokumentation vergleichen) */
        rafterWidthMeasuredAndComparedToDocsState: {
          name: 'rafterWidthMeasuredAndComparedToDocsState',
          fields: [
            'rafterWidthMeasuredAndComparedToDocsState',
            'rafterWidthMeasuredAndComparedToDocsNote',
          ],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'noOpenOrDamagedTilesState',
          predecessor: 'approvedAuxiliaryRafterUsedState',
          completed: this.completedState,
        },
        /** Keine offene oder beschädigte Ziegel? */
        noOpenOrDamagedTilesState: {
          name: 'noOpenOrDamagedTilesState',
          fields: ['noOpenOrDamagedTilesState', 'noOpenOrDamagedTilesNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'noShiftedOrIncorrectlyLaidTilesState',
          predecessor: 'rafterWidthMeasuredAndComparedToDocsState',
          completed: this.completedState,
        },
        /** Modulrahmen unbeschädigt? */
        noShiftedOrIncorrectlyLaidTilesState: {
          name: 'noShiftedOrIncorrectlyLaidTilesState',
          fields: ['noShiftedOrIncorrectlyLaidTilesState', 'noShiftedOrIncorrectlyLaidTilesNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'tilesProperlyCleanedState',
          predecessor: 'noOpenOrDamagedTilesState',
          completed: this.completedState,
        },
        /** Modulglas unbeschädigt */
        tilesProperlyCleanedState: {
          name: 'tilesProperlyCleanedState',
          fields: ['tilesProperlyCleanedState', 'tilesProperlyCleanedNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'correctPanHeadScrewsUsedState',
          predecessor: 'noShiftedOrIncorrectlyLaidTilesState',
          completed: this.completedState,
        },
        /** Richtige Tellerkopfschrauben verwendet? */
        correctPanHeadScrewsUsedState: {
          name: 'correctPanHeadScrewsUsedState',
          fields: ['correctPanHeadScrewsUsedState', 'correctPanHeadScrewsUsedNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'minRailOverhangAfterEndClamp20mmState',
          predecessor: 'tilesProperlyCleanedState',
          completed: this.completedState,
        },
        /** Mindestüberstand der Schiene nach Endklemme größer als 20mm? (ohne Endkappe messen) */
        minRailOverhangAfterEndClamp20mmState: {
          name: 'minRailOverhangAfterEndClamp20mmState',
          fields: ['minRailOverhangAfterEndClamp20mmState', 'minRailOverhangAfterEndClamp20mmNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'distancesToRidgeEavesNotLessThan20cmState',
          predecessor: 'correctPanHeadScrewsUsedState',
          completed: this.completedState,
        },
        /** Abstände zu First/Traufe nicht kleiner als 20cm? */
        distancesToRidgeEavesNotLessThan20cmState: {
          name: 'distancesToRidgeEavesNotLessThan20cmState',
          fields: [
            'distancesToRidgeEavesNotLessThan20cmState',
            'distancesToRidgeEavesNotLessThan20cmNote',
          ],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'moduleClampAreasObservedState',
          predecessor: 'minRailOverhangAfterEndClamp20mmState',
          completed: this.completedState,
        },
        /** Modulklemmbereiche eingehalten? */
        moduleClampAreasObservedState: {
          name: 'moduleClampAreasObservedState',
          fields: ['moduleClampAreasObservedState', 'moduleClampAreasObservedNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'modulesNoDamagesDirtShadingState',
          predecessor: 'distancesToRidgeEavesNotLessThan20cmState',
          completed: this.completedState,
        },
        /** Module keine Beschädigungen */
        modulesNoDamagesDirtShadingState: {
          name: 'modulesNoDamagesDirtShadingState',
          fields: ['modulesNoDamagesDirtShadingState', 'modulesNoDamagesDirtShadingNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'moduleClampsProperlyTightenedState',
          predecessor: 'moduleClampAreasObservedState',
          completed: this.completedState,
        },
        /** Modulklemmen fest? */
        moduleClampsProperlyTightenedState: {
          name: 'moduleClampsProperlyTightenedState',
          fields: ['moduleClampsProperlyTightenedState', 'moduleClampsProperlyTightenedNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'thermalSeparationAfter12mModuleFieldState',
          predecessor: 'modulesNoDamagesDirtShadingState',
          completed: this.completedState,
        },
        /** Thermische Trennung nach 12m Modulfeld? */
        thermalSeparationAfter12mModuleFieldState: {
          name: 'thermalSeparationAfter12mModuleFieldState',
          fields: [
            'thermalSeparationAfter12mModuleFieldState',
            'thermalSeparationAfter12mModuleFieldNote',
          ],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'breakthroughProperlySealedState',
          predecessor: 'moduleClampsProperlyTightenedState',
          completed: this.completedState,
        },
        /** Durchbruch fachgerecht abgedichtet? */
        breakthroughProperlySealedState: {
          name: 'breakthroughProperlySealedState',
          fields: ['breakthroughProperlySealedState', 'breakthroughProperlySealedNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'distanceLightningProtectionToConductivePartsLessThan05mState',
          predecessor: 'thermalSeparationAfter12mModuleFieldState',
          completed: this.completedState,
        },
        /** Backsheet unbeschädigt? */
        distanceLightningProtectionToConductivePartsLessThan05mState: {
          name: 'distanceLightningProtectionToConductivePartsLessThan05mState',
          fields: [
            'distanceLightningProtectionToConductivePartsLessThan05mState',
            'distanceLightningProtectionToConductivePartsLessThan05mNote',
          ],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'gutterUndamagedState',
          predecessor: 'breakthroughProperlySealedState',
          completed: this.completedState,
        },
        /** Regenrinne unbeschädigt? */
        gutterUndamagedState: {
          name: 'gutterUndamagedState',
          fields: ['gutterUndamagedState', 'gutterUndamagedNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'notBuiltOverRoofOverhangState',
          predecessor: 'distanceLightningProtectionToConductivePartsLessThan05mState',
          completed: this.completedState,
        },
        /** Dachüberstand nicht bebaut? */
        notBuiltOverRoofOverhangState: {
          name: 'notBuiltOverRoofOverhangState',
          fields: ['notBuiltOverRoofOverhangState', 'notBuiltOverRoofOverhangNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'cableProperlyLaidInChimneyState',
          predecessor: 'gutterUndamagedState',
          completed: this.completedState,
        },
        /** Kabel im Kamin fachgerecht verlegt? */
        cableProperlyLaidInChimneyState: {
          name: 'cableProperlyLaidInChimneyState',
          fields: ['cableProperlyLaidInChimneyState', 'cableProperlyLaidInChimneyNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'distanceToDisturbingSurfaces10cmObservedState',
          predecessor: 'notBuiltOverRoofOverhangState',
          completed: this.completedState,
        },
        /** Abstand zu Störflachen von 10cm eingehalten? */
        distanceToDisturbingSurfaces10cmObservedState: {
          name: 'distanceToDisturbingSurfaces10cmObservedState',
          fields: [
            'distanceToDisturbingSurfaces10cmObservedState',
            'distanceToDisturbingSurfaces10cmObservedNote',
          ],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'cableEntryWithReplacementPlateAndFlexedTileState',
          predecessor: 'cableProperlyLaidInChimneyState',
          completed: this.completedState,
        },
        /** Flugsparren? */
        cableEntryWithReplacementPlateAndFlexedTileState: {
          name: 'cableEntryWithReplacementPlateAndFlexedTileState',
          fields: [
            'cableEntryWithReplacementPlateAndFlexedTileState',
            'cableEntryWithReplacementPlateAndFlexedTileNote',
          ],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'cablesDoNotRestOnTilesState',
          predecessor: 'distanceToDisturbingSurfaces10cmObservedState',
          completed: this.completedState,
        },
        /** Leitungen ordnungsgemäß verlegt? (nicht auf Ziegeln) */
        cablesDoNotRestOnTilesState: {
          name: 'cablesDoNotRestOnTilesState',
          fields: ['cablesDoNotRestOnTilesState', 'cablesDoNotRestOnTilesNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'cablesLaidProtectedUnderTilesState',
          predecessor: 'cableEntryWithReplacementPlateAndFlexedTileState',
          completed: this.completedState,
        },
        /** Kabelführung unter Ziegel im Schutzrohr verlegt? */
        cablesLaidProtectedUnderTilesState: {
          name: 'cablesLaidProtectedUnderTilesState',
          fields: ['cablesLaidProtectedUnderTilesState', 'cablesLaidProtectedUnderTilesNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'cableEntryOnRoofProperlyDoneState',
          predecessor: 'cablesDoNotRestOnTilesState',
          completed: this.completedState,
        },
        /** Kabelführung an dem Dachhaken befestigt  und im Schutzrohr verlegt? */
        cableEntryOnRoofProperlyDoneState: {
          name: 'cableEntryOnRoofProperlyDoneState',
          fields: ['cableEntryOnRoofProperlyDoneState', 'cableEntryOnRoofProperlyDoneNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'cableLaidThroughChimneyState',
          predecessor: 'cablesLaidProtectedUnderTilesState',
          completed: this.completedState,
        },
        /** Kabel durch Kamin verlegt? */
        cableLaidThroughChimneyState: {
          name: 'cableLaidThroughChimneyState',
          fields: ['cableLaidThroughChimneyState', 'cableLaidThroughChimneyNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'cableLaidInProtectiveSleeveAgainstUvRadiationState',
          predecessor: 'cableEntryOnRoofProperlyDoneState',
          completed: this.completedState,
        },
        /** Kabel im Schutzrohr vor UV-Strahlung verlegt? */
        cableLaidInProtectiveSleeveAgainstUvRadiationState: {
          name: 'cableLaidInProtectiveSleeveAgainstUvRadiationState',
          fields: [
            'cableLaidInProtectiveSleeveAgainstUvRadiationState',
            'cableLaidInProtectiveSleeveAgainstUvRadiationNote',
          ],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'isModuleNotShaded2State',
          predecessor: 'cableLaidThroughChimneyState',
          completed: this.completedState,
        },

        isModuleNotShaded2State: {
          name: 'isModuleNotShaded2State',
          fields: ['isModuleNotShaded2State'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'areModuleClampsNotTwistedState',
          predecessor: 'cableLaidInProtectiveSleeveAgainstUvRadiationState',
          completed: this.completedState,
        },
        areModuleClampsNotTwistedState: {
          name: 'areModuleClampsNotTwistedState',
          fields: ['areModuleClampsNotTwistedState', 'ussWiredProperlyInCabinetNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'isChimneySweeperApprovalGiven2State',
          predecessor: 'isModuleNotShaded2State',
          completed: this.completedState,
        },
        isChimneySweeperApprovalGiven2State: {
          name: 'isChimneySweeperApprovalGiven2State',
          fields: ['isChimneySweeperApprovalGiven2State', 'isChimneySweeperApprovalGiven2Note'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'peCableProperlySecuredState',
          predecessor: 'areModuleClampsNotTwistedState',
          completed: this.completedState,
        },

        /** PE Leitung ordentlich befestigt? */
        peCableProperlySecuredState: {
          name: 'peCableProperlySecuredState',
          fields: ['peCableProperlySecuredState', 'peCableProperlySecuredNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'pvSystemLabeledInOrAtDistributionBoardState',
          predecessor: 'isChimneySweeperApprovalGiven2State',
          completed: this.completedState,
        },

        /** Dokumentation/Projektbericht vorhanden? */
        documentationProjectReportPresentState: {
          name: 'documentationProjectReportPresentState',
          fields: [
            'documentationProjectReportPresentState',
            'documentationProjectReportPresentNote',
          ],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'customerSpecialRequestsConsideredState',
          predecessor: 'peCableProperlySecuredState',
          completed: this.completedState,
        },
        /** Gibt es Sonderwünsche des Kunden und wurden Dokumentiert? */
        customerSpecialRequestsConsideredState: {
          name: 'customerSpecialRequestsConsideredState',
          fields: [
            'customerSpecialRequestsConsideredState',
            'customerSpecialRequestsConsideredNote',
          ],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'flatRooflightningProtectionPresentState',
          predecessor: 'documentationProjectReportPresentState',
          completed: this.completedState,
        },
        /** Blitzschutz vorhanden? */
        flatRooflightningProtectionPresentState: {
          name: 'flatRooflightningProtectionPresentState',
          fields: [
            'flatRooflightningProtectionPresentState',
            'flatRooflightningProtectionPresentNote',
          ],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'isLightningProtectionDistanceToConductivePartsOfPVSystemAtLeast0_5mState',
          predecessor: 'customerSpecialRequestsConsideredState',
          completed: this.completedState,
        },
        isLightningProtectionDistanceToConductivePartsOfPVSystemAtLeast0_5mState: {
          name: 'isLightningProtectionDistanceToConductivePartsOfPVSystemAtLeast0_5mState',
          fields: [
            'isLightningProtectionDistanceToConductivePartsOfPVSystemAtLeast0_5mState',
            'isLightningProtectionDistanceToConductivePartsOfPVSystemAtLeast0_5mNote',
          ],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'properGroundingFlatRoofSystemState',
          predecessor: 'flatRooflightningProtectionPresentState',
          completed: this.completedState,
        },
        /** Fachgerechte Erdung des Flachdachssystems? */
        properGroundingFlatRoofSystemState: {
          name: 'properGroundingFlatRoofSystemState',
          fields: ['properGroundingFlatRoofSystemState', 'properGroundingFlatRoofSystemNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'ballastingAccordingToProjectReportState',
          predecessor: 'isLightningProtectionDistanceToConductivePartsOfPVSystemAtLeast0_5mState',
          completed: this.completedState,
        },
        /** Ballastierung laut Projektbericht angeordnet und gegen Verrutschen gesichert? */
        ballastingAccordingToProjectReportState: {
          name: 'ballastingAccordingToProjectReportState',
          fields: [
            'ballastingAccordingToProjectReportState',
            'ballastingAccordingToProjectReportNote',
          ],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'minimumModuleBearingAreaMaintainedState',
          predecessor: 'properGroundingFlatRoofSystemState',
          completed: this.completedState,
        },
        /** Mindestauflagefläche der Module auf Tower & Base von 20mm eingehalten? */
        minimumModuleBearingAreaMaintainedState: {
          name: 'minimumModuleBearingAreaMaintainedState',
          fields: [
            'minimumModuleBearingAreaMaintainedState',
            'minimumModuleBearingAreaMaintainedNote',
          ],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'qFlatProperlyConnectedState',
          predecessor: 'ballastingAccordingToProjectReportState',
          completed: this.completedState,
        },
        /** Wurden Q.Flat fachgerecht ineinander gesteckt und befestigt? */
        qFlatProperlyConnectedState: {
          name: 'qFlatProperlyConnectedState',
          fields: ['qFlatProperlyConnectedState', 'qFlatProperlyConnectedNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'distanceToDisturbingSurfacesMaintainedState',
          predecessor: 'minimumModuleBearingAreaMaintainedState',
          completed: this.completedState,
        },
        /** Abstand zu Störflächen von 10cm eingehalten? */
        distanceToDisturbingSurfacesMaintainedState: {
          name: 'distanceToDisturbingSurfacesMaintainedState',
          fields: [
            'distanceToDisturbingSurfacesMaintainedState',
            'distanceToDisturbingSurfacesMaintainedNote',
          ],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'flatRoofmoduleClampsProperlyTightenedState',
          predecessor: 'qFlatProperlyConnectedState',
          completed: this.completedState,
        },
        /** Modulklemmen fest? */
        flatRoofmoduleClampsProperlyTightenedState: {
          name: 'flatRoofmoduleClampsProperlyTightenedState',
          fields: [
            'flatRoofmoduleClampsProperlyTightenedState',
            'flatRoofmoduleClampsProperlyTightenedNote',
          ],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'modulesNoDamageDirtShadingState',
          predecessor: 'distanceToDisturbingSurfacesMaintainedState',
          completed: this.completedState,
        },
        /** Module keine Beschädigungen */
        modulesNoDamageDirtShadingState: {
          name: 'modulesNoDamageDirtShadingState',
          fields: ['modulesNoDamageDirtShadingState', 'modulesNoDamageDirtShadingNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'typeOfCableProtectionOutdoorsState',
          predecessor: 'flatRoofmoduleClampsProperlyTightenedState',
          completed: this.completedState,
        },
        /** Module Verschmutzungen? */
        typeOfCableProtectionOutdoorsState: {
          name: 'typeOfCableProtectionOutdoorsState',
          fields: ['typeOfCableProtectionOutdoorsState', 'typeOfCableProtectionOutdoorsNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'correctSelectionOfPvConnectorsState',
          predecessor: 'modulesNoDamageDirtShadingState',
          completed: this.completedState,
        },
        /** Richtige Auswahl der PV-Stecker am Strangkabel? */
        correctSelectionOfPvConnectorsState: {
          name: 'correctSelectionOfPvConnectorsState',
          fields: ['correctSelectionOfPvConnectorsState', 'correctSelectionOfPvConnectorsNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'cablesDoNotRestOnRoofState',
          predecessor: 'typeOfCableProtectionOutdoorsState',
          completed: this.completedState,
        },
        /** Modulklemmen nicht verdreht? */
        cablesDoNotRestOnRoofState: {
          name: 'cablesDoNotRestOnRoofState',
          fields: ['cablesDoNotRestOnRoofState', 'cablesDoNotRestOnRoofNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'isModuleFrameUndamagedState',
          predecessor: 'correctSelectionOfPvConnectorsState',
          completed: this.completedState,
        },
        isModuleFrameUndamagedState: {
          name: 'isModuleFrameUndamagedState',
          fields: ['isModuleFrameUndamagedState', 'isModuleFrameUndamagedNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'isModuleGlassUndamagedState',
          predecessor: 'cablesDoNotRestOnRoofState',
          completed: this.completedState,
        },
        isModuleGlassUndamagedState: {
          name: 'isModuleGlassUndamagedState',
          fields: ['isModuleGlassUndamagedState', 'isModuleGlassUndamagedNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'isBacksheetUndamagedState',
          predecessor: 'isModuleFrameUndamagedState',
          completed: this.completedState,
        },
        isBacksheetUndamagedState: {
          name: 'isBacksheetUndamagedState',
          fields: ['isBacksheetUndamagedState', 'isBacksheetUndamagedNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'isModuleNotShadedState',
          predecessor: 'isModuleGlassUndamagedState',
          completed: this.completedState,
        },
        isModuleNotShadedState: {
          name: 'isModuleNotShadedState',
          fields: ['isModuleNotShadedState', 'isModuleNotShadedNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'cableEntryDoneProperlyState',
          predecessor: 'isBacksheetUndamagedState',
          completed: this.completedState,
        },
        /** Kabelführung an dem Dachhaken befestigt  und im Schutzrohr verlegt? */
        cableEntryDoneProperlyState: {
          name: 'cableEntryDoneProperlyState',
          fields: ['cableEntryDoneProperlyState', 'cableEntryDoneProperlyNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'cablesProtectedFromUvState',
          predecessor: 'isModuleNotShadedState',
          completed: this.completedState,
        },
        /** Kabel im Schutzrohr vor UV-Strahlung verlegt? */
        cablesProtectedFromUvState: {
          name: 'cablesProtectedFromUvState',
          fields: ['cablesProtectedFromUvState', 'cablesProtectedFromUvNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'pvStringCableProperlySizedState',
          predecessor: 'cableEntryDoneProperlyState',
          completed: this.completedState,
        },
        /** PV Strangkabel 6mm² */
        pvStringCableProperlySizedState: {
          name: 'pvStringCableProperlySizedState',
          fields: ['pvStringCableProperlySizedState', 'pvStringCableProperlySizedNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'stringCableLabelingState',
          predecessor: 'cablesProtectedFromUvState',
          completed: this.completedState,
        },
        /** Beschriftung der Strangleitungen? */
        stringCableLabelingState: {
          name: 'stringCableLabelingState',
          fields: ['stringCableLabelingState', 'stringCableLabelingNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'peCableProperlySizedState',
          predecessor: 'pvStringCableProperlySizedState',
          completed: this.completedState,
        },
        /** Funktions-Potentialausgleich zur PAS von  UK=6mm²  */
        peCableProperlySizedState: {
          name: 'peCableProperlySizedState',
          fields: ['peCableProperlySizedState', 'peCableProperlySizedNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'flatRoofcablesProperlySecuredState',
          predecessor: 'stringCableLabelingState',
          completed: this.completedState,
        },
        /** Leitungen befestigt mit Schellen, Rohren, Kabelkanal? */
        flatRoofcablesProperlySecuredState: {
          name: 'flatRoofcablesProperlySecuredState',
          fields: ['flatRoofcablesProperlySecuredState'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'isConnectorProperlyPluggedState',
          predecessor: 'peCableProperlySizedState',
          completed: this.completedState,
        },
        isConnectorProperlyPluggedState: {
          name: 'isConnectorProperlyPluggedState',
          fields: ['isConnectorProperlyPluggedState', 'isConnectorProperlyPluggedNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'isConnectorSealingIntact2State',
          predecessor: 'flatRoofcablesProperlySecuredState',
          completed: this.completedState,
        },
        isConnectorSealingIntact2State: {
          name: 'isConnectorSealingIntact2State',
          fields: ['isConnectorSealingIntact2State', 'isConnectorSealingIntact2Note'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'isCableRoutedThroughChimneyState',
          predecessor: 'isConnectorProperlyPluggedState',
          completed: this.completedState,
        },
        isCableRoutedThroughChimneyState: {
          name: 'isCableRoutedThroughChimneyState',
          fields: ['isCableRoutedThroughChimneyState', 'isCableRoutedThroughChimneyNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'isChimneySweeperApprovalGivenState',
          predecessor: 'isConnectorSealingIntact2State',
          completed: this.completedState,
        },
        isChimneySweeperApprovalGivenState: {
          name: 'isChimneySweeperApprovalGivenState',
          fields: ['isChimneySweeperApprovalGivenState', 'isChimneySweeperApprovalGivenNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'isWallPassageProperlySealedState',
          predecessor: 'isCableRoutedThroughChimneyState',
          completed: this.completedState,
        },
        isWallPassageProperlySealedState: {
          name: 'isWallPassageProperlySealedState',
          fields: ['isWallPassageProperlySealedState', 'isWallPassageProperlySealedNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'crimpingProperlyDoneState',
          predecessor: 'isChimneySweeperApprovalGivenState',
          completed: this.completedState,
        },
        /** Crimpung/Aderendhülsen  fachgerecht durchgeführt? */
        crimpingProperlyDoneState: {
          name: 'crimpingProperlyDoneState',
          fields: ['crimpingProperlyDoneState', 'crimpingProperlyDoneNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'pvSystemLabeledInOrAtDistributionBoardState',
          predecessor: 'isWallPassageProperlySealedState',
          completed: this.completedState,
        },
        /** Ist außen am Schaltschrank die PV Anlage gekennzeichnet? */
        pvSystemLabeledInOrAtDistributionBoardState: {
          name: 'pvSystemLabeledInOrAtDistributionBoardState',
          fields: [
            'pvSystemLabeledInOrAtDistributionBoardState',
            'pvSystemLabeledInOrAtDistributionBoardNote',
          ],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'testReportAvailableWithAllMeasurementsState',
          predecessor: 'crimpingProperlyDoneState',
          completed: this.completedState,
        },

        /** Ist das Prüfprotokoll mit allen Messungen vorhanden? */
        testReportAvailableWithAllMeasurementsState: {
          name: 'testReportAvailableWithAllMeasurementsState',
          fields: [
            'testReportAvailableWithAllMeasurementsState',
            'testReportAvailableWithAllMeasurementsNote',
          ],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'rcdTypeB300maAvailableInMeterAreaState',
          predecessor: 'pvSystemLabeledInOrAtDistributionBoardState',
          completed: this.completedState,
        },

        /** im Nachzählerbereich RCD Typ B 300mA vorhanden? */
        rcdTypeB300maAvailableInMeterAreaState: {
          name: 'rcdTypeB300maAvailableInMeterAreaState',
          fields: [
            'rcdTypeB300maAvailableInMeterAreaState',
            'rcdTypeB300maAvailableInMeterAreaNote',
          ],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'stringPlanFiledInMeterCabinetState',
          predecessor: 'testReportAvailableWithAllMeasurementsState',
          completed: this.completedState,
        },

        /** Stringplan im Zählerschrank hinterlegt? */
        stringPlanFiledInMeterCabinetState: {
          name: 'stringPlanFiledInMeterCabinetState',
          fields: ['stringPlanFiledInMeterCabinetState', 'stringPlanFiledInMeterCabinetNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'safetyDistancesMaintainedState',
          predecessor: 'rcdTypeB300maAvailableInMeterAreaState',
          completed: this.completedState,
        },

        /** Wurden die Sicherheitsabstände eingehalten? */
        safetyDistancesMaintainedState: {
          name: 'safetyDistancesMaintainedState',
          fields: ['safetyDistancesMaintainedState', 'safetyDistancesMaintainedNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'correctLocationForSystemState',
          predecessor: 'stringPlanFiledInMeterCabinetState',
          completed: this.completedState,
        },

        /** Richtiger Aufstellort des Systems? (nicht auf Holz, Witterung…) */
        correctLocationForSystemState: {
          name: 'correctLocationForSystemState',
          fields: ['correctLocationForSystemState', 'correctLocationForSystemNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'correctLocationForWallboxState',
          predecessor: 'safetyDistancesMaintainedState',
          completed: this.completedState,
        },

        /** Wallbox richtiger Aufstellort? */
        correctLocationForWallboxState: {
          name: 'correctLocationForWallboxState',
          fields: ['correctLocationForWallboxState', 'correctLocationForWallboxNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'customerRequestsDocumentedState',
          predecessor: 'correctLocationForSystemState',
          completed: this.completedState,
        },

        /** Falls Kunde etwas anders haben will (z.B. Plastik Kabelabdeckungen anstatt Rohrverlegung) dann muss sowas schriftlich dokumentiert werden */
        customerRequestsDocumentedState: {
          name: 'customerRequestsDocumentedState',
          fields: ['customerRequestsDocumentedState', 'customerRequestsDocumentedNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'slsInstalledState',
          predecessor: 'correctLocationForWallboxState',
          completed: this.completedState,
        },

        /** SLS verbaut? */
        slsInstalledState: {
          name: 'slsInstalledState',
          fields: ['slsInstalledState', 'slsInstalledNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'componentsDamagedState',
          predecessor: 'customerRequestsDocumentedState',
          completed: this.completedState,
        },

        /** Sind Komponenten unbeschädigt? */
        componentsDamagedState: {
          name: 'componentsDamagedState',
          fields: ['componentsDamagedState', 'componentsDamagedNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'crimpingDoneProperlyState',
          predecessor: 'slsInstalledState',
          completed: this.completedState,
        },

        /** Wurde fachgerecht gecrimpt? (Aderendhülsen, Kabelschuhe) */
        crimpingDoneProperlyState: {
          name: 'crimpingDoneProperlyState',
          fields: ['crimpingDoneProperlyState', 'crimpingDoneProperlyNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'ussWiredProperlyInCabinetState',
          predecessor: 'componentsDamagedState',
          completed: this.completedState,
        },

        /** ÜSS im ZS fachgerecht verdrahtet? */
        ussWiredProperlyInCabinetState: {
          name: 'ussWiredProperlyInCabinetState',
          fields: ['ussWiredProperlyInCabinetState', 'ussWiredProperlyInCabinetNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'ussBoxWiredProperlyState',
          predecessor: 'crimpingDoneProperlyState',
          completed: this.completedState,
        },

        /** ÜSS-Box fachgerecht verdrahtet? */
        ussBoxWiredProperlyState: {
          name: 'ussBoxWiredProperlyState',
          fields: ['ussBoxWiredProperlyState', 'ussBoxWiredProperlyNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'bendingRadiiMaintainedState',
          predecessor: 'ussWiredProperlyInCabinetState',
          completed: this.completedState,
        },

        /** Wurden die Biegeradien eingehalten? */
        bendingRadiiMaintainedState: {
          name: 'bendingRadiiMaintainedState',
          fields: ['bendingRadiiMaintainedState', 'bendingRadiiMaintainedNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'correctWiringOfMateboxState',
          predecessor: 'ussBoxWiredProperlyState',
          completed: this.completedState,
        },

        /** Richtige Verkabelung der Matebox? 10mm2 GRID LOAD zum ZS */
        correctWiringOfMateboxState: {
          name: 'correctWiringOfMateboxState',
          fields: ['correctWiringOfMateboxState', 'correctWiringOfMateboxNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'correctWiringOfBatteryState',
          predecessor: 'bendingRadiiMaintainedState',
          completed: this.completedState,
        },

        /** Richtige Verdrahtung der Batterie? */
        correctWiringOfBatteryState: {
          name: 'correctWiringOfBatteryState',
          fields: ['correctWiringOfBatteryState', 'correctWiringOfBatteryNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'allComponentsProperlyGroundedState',
          predecessor: 'correctWiringOfMateboxState',
          completed: this.completedState,
        },

        /** Sind alle Komponenten untereinander geerdet? */
        allComponentsProperlyGroundedState: {
          name: 'allComponentsProperlyGroundedState',
          fields: ['allComponentsProperlyGroundedState', 'allComponentsProperlyGroundedNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'correctColorCodingAndLabelingState',
          predecessor: 'correctWiringOfBatteryState',
          completed: this.completedState,
        },

        /** Richtige Farbauswahl / Beschriftung bei Leitungen? (falls falsche Farbe dann muss Beschriftung da sein!) */
        correctColorCodingAndLabelingState: {
          name: 'correctColorCodingAndLabelingState',
          fields: ['correctColorCodingAndLabelingState', 'correctColorCodingAndLabelingNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'correctWiringOfPvConnectorsState',
          predecessor: 'allComponentsProperlyGroundedState',
          completed: this.completedState,
        },

        /** Richtige Verdrahtung der PV-Stecker von Matebox zum Wechselrichter */
        correctWiringOfPvConnectorsState: {
          name: 'correctWiringOfPvConnectorsState',
          fields: ['correctWiringOfPvConnectorsState', 'correctWiringOfPvConnectorsNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'cableDuctProperlySizedAndCutState',
          predecessor: 'correctColorCodingAndLabelingState',
          completed: this.completedState,
        },

        /** Kabelkanal richtige Dimension und sauberes zuschneiden */
        cableDuctProperlySizedAndCutState: {
          name: 'cableDuctProperlySizedAndCutState',
          fields: ['cableDuctProperlySizedAndCutState', 'cableDuctProperlySizedAndCutNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'nhHakSelectiveToSlsState',
          predecessor: 'correctWiringOfPvConnectorsState',
          completed: this.completedState,
        },

        /** NH HAK selektiv zu SLS */
        nhHakSelectiveToSlsState: {
          name: 'nhHakSelectiveToSlsState',
          fields: ['nhHakSelectiveToSlsState', 'nhHakSelectiveToSlsNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'checkNetworkTypeState',
          predecessor: 'cableDuctProperlySizedAndCutState',
          completed: this.completedState,
        },

        /** Prüfen der Netzart */
        checkNetworkTypeState: {
          name: 'checkNetworkTypeState',
          fields: ['checkNetworkTypeState', 'checkNetworkTypeNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'earthRodConnectedToHpasState',
          predecessor: 'nhHakSelectiveToSlsState',
          completed: this.completedState,
        },

        /** Banderder/Staberder an HPAS angeschlossen? */
        earthRodConnectedToHpasState: {
          name: 'earthRodConnectedToHpasState',
          fields: ['earthRodConnectedToHpasState', 'earthRodConnectedToHpasNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'connectionBetweenHpasAndPasProperlyMadeState',
          predecessor: 'checkNetworkTypeState',
          completed: this.completedState,
        },

        /** Verbindung HPAS/PAS fachgerecht hergestellt? */
        connectionBetweenHpasAndPasProperlyMadeState: {
          name: 'connectionBetweenHpasAndPasProperlyMadeState',
          fields: [
            'connectionBetweenHpasAndPasProperlyMadeState',
            'connectionBetweenHpasAndPasProperlyMadeNote',
          ],
          opened: false,
          navigateTo: this.goToCard,
          successor: 'insulationProperlyStrippedState',
          predecessor: 'earthRodConnectedToHpasState',
          completed: this.completedState,
        },
        /** Isolierung weit genug abisoliert */
        insulationProperlyStrippedState: {
          name: 'insulationProperlyStrippedState',
          fields: ['insulationProperlyStrippedState', 'insulationProperlyStrippedNote'],
          opened: false,
          navigateTo: this.goToCard,
          successor: null,
          predecessor: 'connectionBetweenHpasAndPasProperlyMadeState',
          completed: this.completedState,
        },

        // /** Polaritätsprüfung */
        // polarityCheckState: {
        //   name: 'polarityCheckState',
        //   opened: false,
        //   navigateTo: this.goToCard,
        //   successor: 'stringOpenCircuitVoltageState',
        //   predecessor: 'insulationProperlyStrippedState',
        //   completed: this.completedState,
        // },

        // /** Leerlaufspannung des Strangs */
        // stringOpenCircuitVoltageState: {
        //   name: 'stringOpenCircuitVoltageState',
        //   opened: false,
        //   navigateTo: this.goToCard,
        //   successor: 'shortCircuitCurrentState',
        //   predecessor: 'polarityCheckState',
        //   completed: this.completedState,
        // },

        // /** Kurzschlussstrom */
        // shortCircuitCurrentState: {
        //   name: 'shortCircuitCurrentState',
        //   opened: false,
        //   navigateTo: this.goToCard,
        //   successor: 'insulationResistanceState',
        //   predecessor: 'stringOpenCircuitVoltageState',
        //   completed: this.completedState,
        // },

        // /** Isolationswiderstand */
        // insulationResistanceState: {
        //   name: 'insulationResistanceState',
        //   opened: false,
        //   navigateTo: this.goToCard,
        //   successor: null,
        //   predecessor: 'shortCircuitCurrentState',
        //   completed: this.completedState,
        // },
      },
      selectedProjectStateType: null,
      /** track Upload states for clearing dropzone preview */
    };
  },
  computed: {
    isFlatRoof() {
      return this.project.measurement && this.project.measurement.roofType === 'FLAT_ROOF';
    },
    isPitchedRoof() {
      return this.project.measurement && this.project.measurement.roofType === 'PITCHED_ROOF';
    },
  },

  methods: {
    ...mapActions(['fetchEnumValues']),

    /** The branch targets depend on the roof type (the roof type card sets it). */
    resolveCardTarget(target) {
      if (target === 'documentationProjectReportAvailableState') {
        return this.isFlatRoof
          ? 'documentationProjectReportPresentState'
          : 'documentationProjectReportAvailableState';
      }
      if (target === 'crimpingProperlyDoneState') {
        return this.isPitchedRoof ? 'peCableProperlySecuredState' : 'crimpingProperlyDoneState';
      }
      if (target === 'peCableProperlySecuredState') {
        return this.isFlatRoof
          ? 'surgeProtectionBoxProperlyWiredInstallSpdAtRoofEntryState'
          : 'peCableProperlySecuredState';
      }
      return target;
    },

    toCardInput(report, fieldPaths) {
      return toQualityCardInput(report, fieldPaths, this.project.measurement?.roofType);
    },
  },
  async mounted() {
    await this.fetchEnumValues('YesNoNonVerifiable');
  },
};
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
  gap: 1em;
  flex-flow: row wrap;
  flex-basis: 100%;
  justify-content: flex-start;
}

.flex > div {
  flex: 1;
  min-width: 300px;
}

/** accordion */
.accordion button {
  text-align: left;
  padding: 0.8em 0.5em;
}
.accordion .card,
.accordion .card-header {
  border: 0;
  border-radius: 0em;
}
.accordion .btn.btn-block {
  border: 0;
  border-radius: 0em;
  font-weight: bold;
}
.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}
.accordion {
  position: relative;
  overflow: hidden;
}
</style>
